import { cn } from "../../utils/cn";

interface ToggleButtonProps {
  label: string;
  value: string;
  selected: boolean;
  onToggle?: (value: string, selected: boolean) => void;
  className?: string;
}

const baseStyles =
  "inline-flex items-center justify-center rounded p-2 " +
  "text-body-xs font-semibold leading-none " +
  "border-2 outline-none";

const unselectedStyles =
  "bg-neutral-white border-loch text-loch " +
  "hover:bg-loch-50 " +
  "focus-visible:shadow-[0_0_0_2px] focus-visible:shadow-loch-100 " +
  "active:bg-loch active:border-loch active:text-neutral-white";

const selectedStyles =
  "bg-loch border-loch text-neutral-white " +
  "hover:bg-loch-700 hover:border-loch-700 " +
  "focus-visible:shadow-[0_0_0_2px] focus-visible:shadow-loch-100 " +
  "active:bg-neutral-white active:border-loch active:text-north-sea";

export const ToggleButton = ({ label, value, selected, onToggle, className }: ToggleButtonProps) => {
  const handleClick = () => {
    onToggle?.(value, !selected);
  };

  return (
    <button
      type="button"
      className={cn(baseStyles, selected ? selectedStyles : unselectedStyles, className)}
      onClick={handleClick}
      aria-pressed={selected}
    >
      {label}
    </button>
  );
};
